angular.module("UI8.services").service("ProductService", [
  "$http",
  "$q",
  "PreloadService",
  function ($http, $q, PreloadService) {
    this.homeDigest = function () {
      // Inlined by the homepage shell on the first load
      var preloaded = PreloadService.take("home");
      if (preloaded) return $q.resolve(preloaded);

      return $http.get("/api/home").then(
        function (response) {
          if (response.error) {
            return Promise.resolve({});
          }

          return Promise.resolve(response.data);
        },
        function () {
          return Promise.resolve({});
        }
      );
    };

    this.passPage = function () {
      return $http.get("/api/pass").then(
        function (response) {
          // console.log("passPage - response:");
          // console.log(response);
          if (response.error) {
            return Promise.resolve({});
          }

          // console.log(`pass page returned:`);
          // console.log(response.data);

          return Promise.resolve(response.data);
        },
        function () {
          return Promise.resolve({});
        }
      );
    };

    this.framerPicks = function () {
      return $http.get("/api/framer-picks").then(
        function (response) {
          return Promise.resolve(
            (response.data && response.data.products) || []
          );
        },
        function () {
          return Promise.resolve([]);
        }
      );
    };

    this.list = function (query) {
      return $http.get("/api/products", { params: query }).then(
        function (response) {
          if (response.error) {
            return Promise.resolve({});
          }

          return Promise.resolve(response.data);
        },
        function () {
          return Promise.resolve({});
        }
      );
    };

    this.search = function (query) {
      return $http
        .get("/api/search", { params: query })
        .then(function (response) {
          return Promise.resolve(response.data);
        });
    };

    this.similar = function (
      categories,
      exclude,
      compatibility,
      tags,
      excludeAuthor
    ) {
      return $http
        .get("/api/search/similar", {
          params: { categories, exclude, compatibility, tags, excludeAuthor },
        })
        .then(function (response) {
          return response.data.products || [];
        })
        .catch(function () {
          return [];
        });
    };

    this.featuredAuthorProducts = function () {
      var preloaded = PreloadService.take("featuredAuthorProducts");
      if (preloaded) return $q.resolve(preloaded);

      return $http.get("/api/featured-author").then(function (response) {
        return Promise.resolve(response.data);
      });
    };
  },
]);
